import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { RootStoreState } from 'src/app/store';
import { AudioVideoCheckSelectors } from 'src/app/features/av-check/store/selectors';
import { DuplicateSessionDetectorService } from 'src/app/features/duplicate-session-detector';

import { SideBarContent } from '../components/side-bar';
import { AudioVideoConnectionMonitorService } from '../../audio-video-connection-monitor/services/audio-video-connection-monitor.service';

@Component({
    selector: 'app-pre-session-layout',
    templateUrl: './pre-session-layout.component.html',
    styleUrls: ['./pre-session-layout.component.scss'],
    standalone: false
})
export class PreSessionLayoutComponent implements OnInit, OnDestroy {
  public useAudioVideoConnectionMonitor: boolean;
  public sideBarDynamicContent: SideBarContent;
  private readonly audioVideoConnectionMonitorService = inject(AudioVideoConnectionMonitorService);

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store<RootStoreState.State>,
    private readonly dupDetectorService: DuplicateSessionDetectorService
  ) {}

  ngOnInit() {
    this.useAudioVideoConnectionMonitor = this.audioVideoConnectionMonitorService.shouldUseAudioVideoConnectionMonitor();

    if (this.shouldUseDuplicateSessionDetector()) {
      this.dupDetectorService.enable();
    } else {
      this.dupDetectorService.disable();
    }

    this.sideBarDynamicContent = this.route.snapshot?.data?.sideBarContent;
  }

  ngOnDestroy() {
    this.dupDetectorService.disable();
  }

  shouldUseDuplicateSessionDetector(): boolean {
    return this.route.snapshot?.data && !!this.route.snapshot.data['useDuplicateSessionDetector'];
  }
}
